var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128021(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-128-021-1 {\r\n        fill: #fff;\r\n      }\r\n      .cls-128-021-2,\r\n      .cls-128-021-3 {\r\n        fill: none;\r\n      }\r\n      .cls-128-021-2 {\r\n        stroke: #6e6e6e;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.25px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-021-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M27.48,53.24C22.64,57,22.84,64.12,22.84,64.12s6.43,2.31,11.69-1.77,4.65-10.87,4.65-10.87S32.6,49.28,27.48,53.24Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-021-2",
    x1: 30.29,
    y1: 58.52,
    x2: 22.84,
    y2: 64.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M18.19,53.24C23,57,22.83,64.12,22.83,64.12s-6.43,2.31-11.69-1.77S6.49,51.48,6.49,51.48,13.07,49.28,18.19,53.24Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-021-2",
    x1: 15.38,
    y1: 58.52,
    x2: 22.84,
    y2: 64.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M17.12,42.35c0,6.11,5.79,10.3,5.79,10.3S28.62,49,28.64,42.31,22.85,32,22.85,32,17.1,35.88,17.12,42.35Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-021-2",
    x1: 22.84,
    y1: 44.17,
    x2: 22.83,
    y2: 71.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128-021-2",
    points: "29.3 88.5 16.37 88.5 13.75 71.53 31.92 71.53 29.3 88.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-021-2",
    x: 13.26,
    y: 88.82,
    width: 19.28,
    height: 5.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-021-2",
    x1: 18.25,
    y1: 94.53,
    x2: 13.86,
    y2: 115.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-021-2",
    x1: 27.55,
    y1: 94.53,
    x2: 31.94,
    y2: 115.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M66,55.05C72.2,55.06,71.4,64,79,64c9.62,0,11.77-7.35,18-6.9,9.35.67-5.2,31-17.41,41.32-5.92,5-12.12,6-32.52-8.86-4.55-4.56-3.2-8.74,0-8.59,2.84.13,4.57,2,8.59,2C61.47,82.89,56.48,55,66,55.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M56.3,95.79c10.24.42,9.53-7.18,15.69-7.18S75,95.79,84.78,92.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M91.75,83s-9.17,17.68-14.62,30.47a3.86,3.86,0,0,1-6.42,1.07L47,89.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M49.77,93.45,43,114.24a1.24,1.24,0,0,0,2.19,1.09L64.86,93.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M77.54,92.5l12.25,22a2.2,2.2,0,0,0,4.22-.61L91.75,83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M90.74,43.07H61.42l1.31-5.91A9.49,9.49,0,0,1,72,29.75h8.19a9.48,9.48,0,0,1,9.25,7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M76.08,29.75h0A17.59,17.59,0,0,1,93.67,12.16h.94A17.6,17.6,0,0,1,112.2,29.75V110.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M121.53,115.82H102.86l.84-2.32c.62-1.7,3.07-2.9,5.89-2.9h5.22c2.82,0,5.27,1.2,5.88,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-021-2",
    d: "M79.3,43.07a3.76,3.76,0,1,1-7.51,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128021);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_021.a65a21e83e9e9a90b0be8bdb673f19ea.svg";
export { ForwardRef as ReactComponent };